<template>
  <CompanyBranding isMSDCustom :customCompanyId="companyId" :customActivePage="activePage"></CompanyBranding>
</template>

<script>
import CompanyBranding from '../../mobile/companyInfo/index.vue'
export default {
  components: {
    CompanyBranding
  },
  props: {
    customCompanyId: {
      required: true
    }
  },
  computed: {
    companyId () {
      return this.customCompanyId
    },
    activePage () {
      return this.$route.meta?.pageType
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
